module.exports = __webpack_public_path__ + "static/don28-751a39dd84d69eb9c2590adf96cf87af.jpg";